import { render, staticRenderFns } from "./OrdenTrabajoCard.vue?vue&type=template&id=ddebf004&scoped=true&"
import script from "./OrdenTrabajoCard.vue?vue&type=script&lang=js&"
export * from "./OrdenTrabajoCard.vue?vue&type=script&lang=js&"
import style0 from "./OrdenTrabajoCard.vue?vue&type=style&index=0&id=ddebf004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddebf004",
  null
  
)

export default component.exports